<template>
  <div v-if="visible" class="fullscreen_wrapper flex-column">
    <div class="propject_detail_info_handlers pd10 col-0 flex-row">
      <div ref="editBtn" class="propject_detail_other_handlers">
        <el-button :disabled="projectPending" type="primary" size="mini" @click="onSave">保存 / 提交</el-button>
      </div>
      <el-button type="danger" size="mini" @click="showDialog('客户特殊要求')">客户特殊要求 ！</el-button>&nbsp;&nbsp;
      <el-button type="primary" size="mini" @click="showDialog('复制项目')">从已有项目复制</el-button>
      <div class="propject_detail_info_close_btn" @click="close"><i class="el-icon-error" /></div>
    </div>
    <div class="flex-row col-1 scroll pd10">
      <div class="col-1">
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">基本信息</p>
          <div class="flex-row flex-wrap">
            <div class="flex-row item-center mr10 mb5">
              <div
                :class="`col-0 propject_detail_info_label mr5 ${errors['客户公司'] ? 'ft-danger' : ''}`"
                title="必填项"
              >
                客户公司 <i class="el-icon-info" />
              </div>
              <el-autocomplete
                v-model="project['客户公司']"
                :fetch-suggestions="searchCompany"
                size="mini"
                placeholder="搜索关键字"
                class="col-1"
              />
            </div>
            <div class="mr10 mb5">
              <el-popover v-model="addCompanyVisible" placement="right" width="400" trigger="click">
                <div>
                  <div class="flex-row mb10">
                    <span
                      :class="
                        `propject_detail_info_label col-0 propject_detail_info_files_cell_1 ${
                          errors['公司全称'] ? 'ft-danger' : ''
                        }`
                      "
                      title="必填项"
                    >
                      公司全称 <i class="el-icon-info" />
                    </span>
                    <el-autocomplete
                      v-model="companyFullname"
                      :fetch-suggestions="searchCompanyFullname"
                      placeholder="搜索关键字"
                      size="mini"
                      class="col-1"
                    />
                  </div>
                  <div class="flex-row mb10">
                    <span class="propject_detail_info_label col-0 propject_detail_info_files_cell_1" title="必填项">
                      简称 <i class="el-icon-info" />
                    </span>
                    <el-input v-model="companyShortname" :disabled="true" class="col-1" size="mini" />
                  </div>
                  <div class="flex-row mb10">
                    <span
                      :class="
                        `propject_detail_info_label col-0 propject_detail_info_files_cell_1 ${
                          errors['行业'] ? 'ft-danger' : ''
                        }`
                      "
                      title="必填项"
                    >
                      行业 <i class="el-icon-info" />
                    </span>
                    <el-select v-model="companyIndustry" filterable size="mini">
                      <el-option v-for="(value, i) in industry" :key="i" :value="value" :label="value" />
                    </el-select>
                  </div>
                  <div class="text-right">
                    <el-button size="mini" @click="addCompanyVisible = false">取 消</el-button>
                    <el-button
                      :disabled="companyPendding || errors['公司全称']"
                      size="mini"
                      type="primary"
                      @click="createCompany"
                      >确 定</el-button
                    >
                  </div>
                </div>
                <el-button slot="reference" :disabled="showNewComBtn" type="primary" size="mini">新建公司</el-button>
              </el-popover>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">部门</div>
              <el-input v-model="project['部门']" size="mini" class="col-1" />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div
                :class="`col-0 propject_detail_info_label mr5 ${errors['项目名称'] ? 'ft-danger' : ''}`"
                title="必填项"
              >
                项目名称 <i class="el-icon-info" />
              </div>
              <el-input v-model="project['项目名称']" size="mini" class="col-1" />
            </div>
            <div class="flex-row item-center mb5">
              <div class="col-0 propject_detail_info_label mr5">办公地</div>
              <div class="col-1">
                <el-select
                  v-model="project['办公地']"
                  multiple
                  filterable
                  allow-create
                  placeholder="搜索关键字"
                  size="mini"
                  class="full-width"
                >
                  <el-option v-for="(value, i) in locations" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">参与成员</div>
              <div class="project_members_label" @click="editPartners">{{ projectMembers.toString() }}</div>
              &nbsp;
              <el-button type="primary" size="mini" @click="editPartners">编辑参与成员</el-button>
            </div>
          </div>
          <div v-show="!baseInfoCollapsed" class="flex-row flex-wrap">
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">开始日期</div>
              <el-date-picker
                v-model="project.startTime"
                type="date"
                size="mini"
                value-format="timestamp"
                class="mini_datetime_picker project_info_datepicker"
              />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">保证期</div>
              <el-date-picker
                v-model="project.guaranteeTime"
                type="date"
                size="mini"
                value-format="timestamp"
                class="mini_datetime_picker project_info_datepicker"
              />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">预计第一批人推荐时间</div>
              <el-date-picker
                v-model="project.indroduceTime"
                type="date"
                size="mini"
                value-format="timestamp"
                class="mini_datetime_picker project_info_datepicker"
              />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">年龄要求</div>
              <div class="flex-row item-center">
                <el-input v-model="project['年龄要求'][0]" class="project_detail_number_input" size="mini" />~
                <el-input v-model="project['年龄要求'][1]" class="project_detail_number_input" size="mini" />年
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">工作年限</div>
              <div class="flex-row item-center">
                <el-input v-model="project['工作年限'][0]" class="project_detail_number_input" size="mini" />~
                <el-input v-model="project['工作年限'][1]" class="project_detail_number_input" size="mini" />年
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">年薪范围</div>
              <div class="flex-row item-center">
                <el-input v-model="project['年薪范围'][0]" class="project_detail_number_input" size="mini" />~
                <el-input v-model="project['年薪范围'][1]" class="project_detail_number_input" size="mini" />万
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">月薪范围</div>
              <div class="flex-row item-center">
                <el-input v-model="project['月薪范围'][0]" class="project_detail_number_input" size="mini" />~
                <el-input v-model="project['月薪范围'][1]" class="project_detail_number_input" size="mini" />万
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">项目状态</div>
              <div class="project_detail_select_input">
                <el-select v-model="project['项目状态']" filterable size="mini">
                  <el-option v-for="(value, i) in projectStatus" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">专业职级</div>
              <div>
                <el-select v-model="project['专业职级']" multiple filterable size="mini">
                  <el-option v-for="(item, i) in professionalRank" :key="i" :value="item.value" :label="item.label" />
                </el-select>
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">管理职级</div>
              <el-input v-model="project['管理职级']" size="mini" class="col-1" />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">招聘数量</div>
              <div class="project_detail_number_input col-1">
                <el-input v-model="project['招聘数量']" size="mini" />
              </div>
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">优先级</div>
              <el-rate v-model="project['优先级']" :colors="['#99A9BF', '#F7BA2A', '#F56C6C']" />
            </div>
            <div class="flex-row item-center mr10 mb5">
              <div class="col-0 propject_detail_info_label mr5">独家职位：</div>
              <el-checkbox v-model="project['独家']"></el-checkbox>
            </div>
          </div>
          <div class="text-right">
            <a v-show="baseInfoCollapsed" @click="baseInfoCollapsed = !baseInfoCollapsed">
              更多 <i class="el-icon-caret-bottom" />
            </a>
            <a v-show="!baseInfoCollapsed" @click="baseInfoCollapsed = !baseInfoCollapsed">
              收起 <i class="el-icon-caret-top" />
            </a>
          </div>
        </div>
        <div>
          <p class="propject_detail_info_title">
            <span class="mr10">智能填写</span>
            <span class="mr10">
              <el-button type="primary" size="mini" @click="parseTemplateText()">解析</el-button>
            </span>
            <!-- <span class="mr10">
              <el-button type="primary" size="mini" @click="upload('', 1)">上传并解析</el-button>
            </span>-->
            <span class="mr10">
              <el-button type="primary" size="mini" @click="download({ url: `${host}/upload/项目信息模板.docx` })"
                >下载模板</el-button
              >
            </span>
            <span class="ft-gray ft-small"
              >1、下载模板 2、按照模板填写内容 3、将内容复制并粘贴至下面的文本框内 4、点击解析</span
            >
          </p>
          <el-input
            v-model="templateText"
            type="textarea"
            size="mini"
            placeholder="粘贴按照模板格式写好的文字内容，然后点击解析"
            :autosize="{ minRows: 2, maxRows: 6 }"
          />
        </div>
        <div class="flex-row justify-between">
          <div class="col-6 propject_detail_info_block">
            <p class="propject_detail_info_title">
              岗位要求 <a @click="upload('岗位要求')"> <i class="el-icon-circle-plus" /> </a>
            </p>
            <el-input v-model="project['岗位要求']" type="textarea" size="mini" autosize />
          </div>
          <div class="col-6 propject_detail_info_block">
            <p class="propject_detail_info_title">
              岗位职责 <a @click="upload('岗位职责')"> <i class="el-icon-circle-plus" /> </a>
            </p>
            <el-input v-model="project['岗位职责']" type="textarea" autosize />
          </div>
        </div>
        <!-- 对接hr -->
        <div class="propject_detail_info_block">
          <div
            :class="
              `propject_detail_info_title col-0 propject_detail_info_label mr5 ${errors['对接hr'] ? 'ft-danger' : ''}`
            "
            title="必填项"
          >
            对接hr <i class="el-icon-info" />
          </div>
          <p class="propject_detail_info_label col-0 mr10">
            对接HR
            <el-popover v-if="company._id" v-model="companyHRVisible" placement="right" width="800" trigger="click">
              <div class="propject_detail_info_table col-1">
                <p style="text-align:center"><a @click="insertCompanyHr">新增</a>一位hr</p>
                <div class="flex-row project_table_thead">
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">手机</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">座机</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">邮箱</span>
                </div>
                <div
                  v-for="(value, i) in company['对接hr']"
                  :key="i"
                  :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                  @click="addProjectHR(value)"
                >
                  <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
                </div>
              </div>
              <a slot="reference"> <i class="el-icon-search" /> </a>
            </el-popover>
          </p>
          <div class="display-flex flex-wrap">
            <div v-for="(item, index) in projectHRs" :key="`interview${index}`" class="radish-card mr10 mb5">
              <span class="close" @click="removeProjectHr(item)">X</span>
              <div style="width:40%">
                <span class="name">
                  <!-- {{item.姓名}} -->
                  <span :class="{ 'drawer-link': item.rid }" @click="showRadish({ id: item._id })">{{
                    item.姓名
                  }}</span>
                </span>
                <span class="name" style="color:#000">
                  <span>{{ item.目前职位 }}</span>
                </span>
              </div>
              <div class="width:60%">
                <p class="tel">{{ item.手机 }}</p>
                <p>{{ item.座机 }}</p>
                <p>{{ item.邮箱 }}</p>
              </div>
            </div>
          </div>

          <!-- 面试地址 -->
          <el-popover v-if="company._id" v-model="companyAddressVisible" placement="right" width="800" trigger="click">
            <div class="propject_detail_info_table col-1" style="font-size:14px">
              <div class="flex-row justify-between project_table_thead item-center" style="min-height:40px">
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
              </div>
              <div
                v-for="(value, i) in company['面试地址']"
                :key="`address${i}`"
                style="min-height:40px"
                :class="
                  `flex-row justify-between propject_detail_info_table_row_link item-center ${
                    i % 2 === 0 ? 'bg-gray' : ''
                  }`
                "
                @click="addAddress2Project(value)"
              >
                <span class="propject_detail_info_table_cell col-1">{{ value['地址'] }}</span>
                <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
              </div>
            </div>
            <a slot="reference" style="display: flex;word-break: keep-all;">
              面试地址 <i class="el-icon-circle-plus mb10" />
            </a>
          </el-popover>
          <div class="flex-row mb10">
            <div
              v-if="project['面试地址'] && project['面试地址'].length > 0"
              class="propject_detail_info_table col-1"
              style="font-size:14px"
            >
              <div class="flex-row justify-between project_table_thead item-center" style="min-height:40px">
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
              </div>
              <div
                v-for="(value, i) in project['面试地址']"
                :key="`address${i}`"
                style="min-height:40px"
                :class="`flex-row justify-between item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
              >
                <a class="col-0" @click="removeCompanyAddress(value._id)"> <i class="el-icon-remove" /> </a>
                <span class="propject_detail_info_table_cell col-1">{{ value['地址'] }}</span>
                <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">
            核心要求 <a @click="upload('核心要求')"> <i class="el-icon-circle-plus" /> </a>
          </p>
          <el-input v-model="project['核心要求']" type="textarea" autosize />
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">公司亮点及优势</p>
          <el-input v-model="project['公司亮点及优势']" type="textarea" autosize />
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">项目亮点及优势</p>
          <el-input v-model="project['项目亮点及优势']" type="textarea" autosize />
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">职位劣势及风险点</p>
          <el-input v-model="project['职位劣势及风险点']" type="textarea" autosize />
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">岗位薪酬</p>
          <el-input v-model="project['岗位薪酬']" type="textarea" autosize />
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">寻访方向</p>
          <el-input v-model="project['寻访方向']" type="textarea" autosize />
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">可能的问题及应对</p>
          <el-input v-model="project['可能的问题及应对']" type="textarea" autosize />
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">职位话术</p>
          <el-input v-model="project['项目话术']" type="textarea" autosize />
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">部门详情</p>
          <el-input v-model="project['部门详情']" type="textarea" autosize />
        </div>
        <!-- <div v-if="company._id" class="propject_detail_info_block">
          <div class="propject_detail_info_title">
            客户公司分析
            <el-input v-model="company['一句话简介']" type="textarea" autosize />
          </div>
          <div class="flex-row justify-between">
            <div class="col-6 flex-column">
              <p class="propject_detail_info_label col-0">公司亮点</p>
              <div class="flex-row flex-wrap mb5">
                <a
                  v-for="(value, key, index) in company['公司亮点'].keywords"
                  :key="index"
                  :class="`${value ? 'label_tag' : 'label_tag_default'}`"
                  @click="company['公司亮点'].keywords[key] = !company['公司亮点'].keywords[key]"
                  >{{ key }}</a
                >
              </div>
              <textarea v-model="company['公司亮点'].content" class="col-1 info_textarea" />
            </div>
            <div class="col-6 flex-column">
              <p class="propject_detail_info_label col-0">部门情况</p>
              <textarea v-model="company['部门情况']" class="col-1 info_textarea" />
            </div>
          </div>
          <div class="flex-row mb10">
            <p class="propject_detail_info_label col-0 mr10">
              对接HR
              <el-popover v-if="company._id" v-model="companyHRVisible" placement="right" width="800" trigger="click">
                <div class="propject_detail_info_table col-1">
                  <p style="text-align:center"><a @click="insertCompanyHr">新增</a>一位hr</p>
                  <div class="flex-row project_table_thead">
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">手机</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">座机</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">邮箱</span>
                  </div>
                  <div
                    v-for="(value, i) in company['对接hr']"
                    :key="i"
                    :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                    @click="addHR2Project(value)"
                  >
                    <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
                  </div>
                </div>
                <a slot="reference"> <i class="el-icon-search" /> </a>
              </el-popover>
            </p>
            <div class="propject_detail_info_table col-1">
              <div class="flex-row project_table_thead">
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">手机</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">座机</span>
                <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">邮箱</span>
              </div>
              <div
                v-for="(value, i) in projectHRs"
                :key="`projectHR${i}`"
                :class="`flex-row item-center propject_detail_info_table_row_delete ${i % 2 === 0 ? 'bg-gray' : ''}`"
              >
                <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
                <i class="el-icon-delete" @click="removeProjectHr(value)" />
              </div>
              <div
                v-for="(value, i) in temporaryHr"
                :key="`temporary${i}`"
                :class="`flex-row item-center propject_detail_info_table_row_delete ${i % 2 === 0 ? 'bg-gray' : ''}`"
              >
                <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['手机'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['座机'] }}</span>
                <span class="propject_detail_info_table_cell col-2">{{ value['邮箱'] }}</span>
                <i class="el-icon-delete" @click="removeTemporaryHr(value)" />
              </div>
            </div>
          </div>
          <div class="flex-row mb10">
            <p class="propject_detail_info_label col-0 mr10">
              面试地址 <a @click="toAddAddress"> <i class="el-icon-circle-plus" /> </a>
            </p>
            <div class="propject_detail_info_table col-1">
              <div class="flex-row justify-between project_table_thead">
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">地址</span>
                <span class="propject_detail_info_table_cell col-6 propject_detail_info_label">备注</span>
              </div>
              <div
                v-for="(value, i) in company['面试地址']"
                :key="i"
                :class="`flex-row justify-between item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
              >
                <a class="col-0" @click="removeCompanyAddress(value._id, i)"> <i class="el-icon-remove" /> </a>
                <span class="propject_detail_info_table_cell col-1">{{ value['地址'] }}</span>
                <span class="propject_detail_info_table_cell col-6">{{ value['备注'] }}</span>
              </div>
            </div>
          </div>
          <div class="flex-row justify-between">
            <div class="col-4 flex-column">
              <p class="propject_detail_info_label col-0">薪酬概况</p>
              <textarea v-model="company['薪酬/职级/奖金机制']" class="col-1 info_textarea" />
            </div>
            <div class="col-4 flex-column">
              <p class="propject_detail_info_label col-0">业务特点/风格/资源来源</p>
              <div class="flex-row flex-wrap">
                <a
                  v-for="(value, key, index) in company['业务特点/风格/资源来源'].keywords"
                  :key="index"
                  :class="`${value ? 'label_tag' : 'label_tag_default'}`"
                  @click="company['业务特点/风格/资源来源'].keywords[key] = !value"
                  >{{ companyKeyWordLabel[key] }}</a
                >
              </div>
              <textarea v-model="company['业务特点/风格/资源来源'].content" class="col-1 info_textarea" />
            </div>
            <div class="col-4 flex-column">
              <p class="propject_detail_info_label col-0">面试安排</p>
              <textarea v-model="company['面试安排']" class="col-1 info_textarea" />
            </div>
          </div>
        </div> -->
        <!-- <div v-if="company._id" class="propject_detail_info_block">
          <p class="propject_detail_info_title">
            领导介绍
            <el-popover
              v-if="company._id"
              v-model="companyLeadersVisible"
              placement="right"
              trigger="click"
              width="600"
            >
              <div class="propject_detail_info_table col-1">
                <p>没有找到想要的信息？点击 <a @click="showAddCompanyLeaderDialog">搜索</a>在数据库中搜索人选</p>
                <div class="flex-row project_table_thead">
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                  <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                  <span class="propject_detail_info_table_cell col-1 propject_detail_info_label">简介</span>
                </div>
                <div
                  v-for="(value, i) in company['领导']"
                  :key="i"
                  :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                  @click="addLeader2Project(value._id)"
                >
                  <span class="propject_detail_info_table_cell col-2">{{ value.姓名 }}</span>
                  <span class="propject_detail_info_table_cell col-2">{{ value.目前职位 }}</span>
                  <span class="propject_detail_info_table_cell col-1">{{ value.简介 }}</span>
                </div>
              </div>
              <a slot="reference"> <i class="el-icon-search" /> </a>
            </el-popover>
          </p>
          <el-input v-model="company['领导介绍']" placeholder="领导介绍" type="textarea" autosize class="mb5" />
          <div class="propject_detail_info_table col-1">
            <div class="flex-row justify-between project_table_thead">
              <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
              <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
              <span class="propject_detail_info_table_cell col-1 propject_detail_info_label">介绍</span>
              <span class="propject_detail_info_table_cell col-2 propject_detail_info_label" />
            </div>
            <div
              v-for="(value, i) in projectLeaders"
              :key="i"
              :class="
                `flex-row justify-between item-center propject_detail_info_table_row_delete ${
                  i % 2 === 0 ? 'bg-gray' : ''
                }`
              "
            >
              <span class="propject_detail_info_table_cell col-2">{{ value.姓名 }}</span>
              <span class="propject_detail_info_table_cell col-2">{{ value.目前职位 }}</span>
              <span class="propject_detail_info_table_cell col-1">{{ value.简介 }}</span>
              <span class="propject_detail_info_table_cell col-2">
                <a v-if="value.rid" @click="getRadishAtta(value.rid)"> <i class="el-icon-document" />附件 </a>
              </span>
              <i class="el-icon-delete" @click="removeProjectLeader(value._id, i)" />
            </div>
          </div>
        </div> -->
      </div>
      <div ref="propject_detail_secondary" class="col-0 propject_detail_secondary">
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">人才画像</p>

          <!-- 编辑 -->
          <div class="flex-row flex-wrap propject_detail_info_block_item">
            <div class="flex-row col-6 mb5">
              <div :class="`col-0 propject_detail_info_label mr5 ${errors['职能模块'] ? 'ft-danger' : ''}`">
                职能模块
              </div>
              <el-autocomplete
                v-model="project['职能模块']"
                :fetch-suggestions="(queryString, cb) => autocomplateSuggestions(queryString, cb, categoryOptions)"
                size="mini"
                placeholder="搜索关键字"
                class="col-1"
              />
            </div>
            <div class="flex-row col-6 mb5">
              <div :class="`col-0 propject_detail_info_label mr5 ${errors['平台'] ? 'ft-danger' : ''}`">平台</div>
              <div class="col-1">
                <el-select v-model="project['平台']" multiple size="mini" class="full-width">
                  <el-option v-for="(value, i) in ['A', 'B', 'C']" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
            <div class="flex-row col-6 mb5">
              <div class="col-0 propject_detail_info_label mr5">细分职能</div>
              <div class="col-1">
                <el-select v-model="project['细分职能']" multiple filterable size="mini" class="full-width">
                  <el-option v-for="(value, i) in 细分职能options" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
            <div class="flex-row col-6 mb5">
              <div :class="`col-0 propject_detail_info_label mr5 ${errors['业绩'] ? 'ft-danger' : ''}`">业绩</div>
              <div class="col-1">
                <el-select v-model="project['业绩']" multiple filterable size="mini" class="full-width">
                  <el-option v-for="(value, i) in 业绩options" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
            <div class="flex-row col-6 mb5">
              <div class="col-0 propject_detail_info_label mr5">擅长方向</div>
              <div class="col-1">
                <el-select v-model="project['擅长方向']" multiple filterable size="mini" class="full-width">
                  <el-option v-for="(value, i) in 擅长方向options" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
            <div class="flex-row col-6 mb5">
              <div :class="`col-0 propject_detail_info_label mr5 ${errors['职级'] ? 'ft-danger' : ''}`">职级</div>
              <div class="col-1">
                <el-select v-model="project['职级']" multiple filterable size="mini" class="full-width">
                  <el-option v-for="(item, i) in professionalLevel" :key="i" :value="item.value" :label="item.label" />
                </el-select>
              </div>
            </div>
            <div class="flex-row col-6 mb5">
              <div class="col-0 propject_detail_info_label mr5">目标行业</div>
              <div class="col-1">
                <el-select v-model="project['目标行业']" multiple filterable size="mini" class="full-width">
                  <el-option v-for="(value, i) in industry" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
            <div class="flex-row col-6 mb5">
              <div :class="`col-0 propject_detail_info_label mr5 ${errors['地域'] ? 'ft-danger' : ''}`">地域</div>
              <div class="col-1">
                <el-select v-model="project['地域']" multiple filterable allow-create size="mini" class="full-width">
                  <el-option v-for="(value, i) in locations" :key="i" :value="value" :label="value" />
                </el-select>
              </div>
            </div>
          </div>
          <div>
            <!-- <SlickList v-if="project['标签']" v-model="project['标签']" lock-axis="y">
              <SlickItem
                v-for="(tag, i) in project['标签']"
                :index="i"
                :key="i"
                :class="
                  `propject_detail_info_tag_item grab ${i < 5 ? `deep_orange_${i}` : 'deep_orange_5'} ${
                    i < 5 ? `max_width_${i}` : 'max_width_5'
                  }`
                "
              >{{ tag }}</SlickItem>
            </SlickList>-->
            <el-alert title="标签可拖拽排序，前五会重点展示" type="warning" style="margin:4px 0" />
            <div class="tagsort-box">
              <el-tag
                v-for="(tag, index) in project['标签']"
                :key="index"
                size="mini"
                style="margin:0 4px 4px 0"
                closable
                draggable="true"
                type="warning"
                @drop.native="event => drop(event, index)"
                @dragover.native="event => allowDrop(event, index)"
                @dragstart.native="() => drag(index)"
                @close="dragtagclose(tag, index)"
                >{{ tag }}</el-tag
              >
            </div>
            <div>
              <el-input
                v-if="tagInputVisible"
                ref="saveTagInput"
                v-model="tagInput"
                size="mini"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              />
              <el-button v-else class="button-new-tag" size="mini" @click="showInput">+ 新标签</el-button>
            </div>
            <div v-for="(tagGroup, i) in tags" :key="i" class="pd-10">
              <div class="project-item-label">{{ tagGroup.label }}</div>
              <el-checkbox-group v-model="project['标签']" class="flex-row flex-wrap">
                <el-checkbox v-for="tag in tagGroup.children" :key="tag" :label="tag" class="check-item mr10" />
              </el-checkbox-group>
            </div>
          </div>

          <div>
            <p class="propject_detail_info_title">
              目标公司 <a @click="selectCompany"> <i class="el-icon-circle-plus" /> </a>
            </p>
            <div><el-input v-model="project['目标公司备注']" placeholder="目标公司" type="textarea" autosize /></div>
            <div class="flex-row flex-wrap">
              <span v-for="(value, i) in project['目标公司']" :key="i" class="label_tag">{{ value }}</span>
            </div>
          </div>
          <div>
            <p class="propject_detail_info_title">
              目标人选 <a @click="editProjectTargetRadishes"> <i class="el-icon-circle-plus" /> </a>
            </p>
            <div><el-input v-model="project['目标人选备注']" placeholder="目标人选" type="textarea" autosize /></div>
            <div class="flex-row flex-wrap">
              <span v-for="(value, i) in project['目标人选']" :key="i" class="label_tag">{{ value.name }}</span>
            </div>
          </div>

          <div>
            <p class="propject_detail_info_title">阿尔法认知</p>
            <div><el-input v-model="project['阿尔法认知']" placeholder="阿尔法认知" type="textarea" autosize /></div>
          </div>
        </div>
        <div class="propject_detail_info_block">
          <p class="propject_detail_info_title">
            附件 <a @click="beforeUpload"> <i class="el-icon-circle-plus" /> </a>
          </p>
          <div class="propject_detail_info_table">
            <div class="flex-row project_table_thead">
              <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 propject_detail_info_label"
                >类型</span
              >
              <span
                class="propject_detail_info_table_cell propject_detail_info_files_cell_1 propject_detail_info_label col-1"
                >文件名</span
              >
              <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 propject_detail_info_label"
                >上传时间</span
              >
              <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 propject_detail_info_label"
                >上传人</span
              >
              <span class="propject_detail_info_table_cell propject_detail_info_files_cell_4 propject_detail_info_label"
                >操作</span
              >
            </div>
            <div v-for="(value, i) in files" :key="i" :class="`flex-row item-center ${i % 2 === 0 ? 'bg-gray' : ''}`">
              <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 col-0">{{
                value.type
              }}</span>
              <a
                class="propject_detail_info_table_cell propject_detail_info_files_cell_1 col-1"
                @click="previewFile(value)"
                >{{ value.originalname }}</a
              >
              <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 col-0">{{
                value.createdAt ? dateFormat(new Date(parseInt(value.createdAt, 10)), 'yyyy-mm-dd') : '--'
              }}</span>
              <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 col-0">{{
                value.uploader
              }}</span>
              <a
                v-if="userInservice"
                class="propject_detail_info_table_cell propject_detail_info_files_cell_4 col-0"
                @click="download(value)"
                >下载</a
              >
            </div>
          </div>
        </div>

        <div class="propject_detail_info_block">
          <!-- <p class="propject_detail_info_title">
            附件 <a @click="beforeUpload"> <i class="el-icon-circle-plus" /> </a>
          </p> -->
          <div class="propject_detail_info_table">
            <div>
              <p style="padding: 8px;font-size: 16px;">客户最关注的问题</p>
              <div
                v-for="(question, index) in company.关注问题"
                :key="`question${index}`"
                class="display-flex align-center mb5"
              >
                <span class="mr5">Q:</span>
                <p>{{ question }}</p>
              </div>

              <div
                v-for="(question, index) in project.关注问题"
                :key="`projectQuestion${index}`"
                class="display-flex align-center mb5"
              >
                <span class="mr5">Q:</span>
                <el-input
                  v-model="project.关注问题[index]"
                  placeholder="输入的问题会自动进入人选会谈"
                  class="mr5"
                  size="mini"
                ></el-input>
                <i class="ft-danger el-icon-delete" @click="removeQuestion(index)" />
              </div>
              <a @click="addQuestion"> <i class="el-icon-circle-plus" />增加一条问题 </a>
            </div>
            <div>
              <p style="padding: 8px;font-size: 16px;">面试流程及面试安排</p>
              <div class="display-flex">
                <span class="keep-all">面试流程：</span>
                <el-input
                  v-model="project.面试流程"
                  type="textarea"
                  :rows="3"
                  :placeholder="
                    `例如：业务线电话直接约面试--业务领导见面（可能3个业务线的，也有可能直接部门B角）-A角见面-见投行委领导-后期可能会有测试（要考英语，财管计算等）`
                  "
                >
                </el-input>
              </div>
            </div>
            <div>
              <a @click="addInterviewer"> 关键面试决策人<i class="el-icon-circle-plus mb10" /> </a>
              <div class="display-flex flex-wrap">
                <div v-for="(item, index) in interviewer" :key="`interview${index}`" class="radish-card mr10 mb5">
                  <span class="close" @click="removeInterviewer(item)">X</span>
                  <div style="width:40%">
                    <span class="name">
                      <!-- {{item.姓名}} -->
                      <span class="drawer-link" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
                    </span>
                    <span class="name" style="color:#000">
                      <span>{{ item.目前职位 }}</span>
                    </span>
                  </div>
                  <div class="width:60%">
                    <p class="tel">{{ item.手机 }}</p>
                    <p>{{ item.座机 }}</p>
                    <p>{{ item.邮箱 }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" :modal="false">
      <div v-if="dialogTitle === '参与成员'">
        <div class="flex-row mb5">
          <div :class="`col-0 propject_detail_info_label mr5 ${errors['客户开发'] ? 'ft-danger' : ''}`">客户开发</div>
          <!-- <a class="col-0 mr5" @click="addPartner('客户开发')">
            <i class="el-icon-circle-plus"/>
          </a>-->
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['客户开发']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['客户开发'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('客户开发', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['客户开发'].length - 1" class="col-0 mr5" @click="addPartner('客户开发')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-row mb5">
          <div :class="`col-0 propject_detail_info_label mr5 ${errors['项目对接'] ? 'ft-danger' : ''}`">项目对接</div>
          <!-- <a class="col-0 mr5" @click="addPartner('项目对接')">
            <i class="el-icon-circle-plus"/>
          </a>-->
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['项目对接']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['项目对接'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('项目对接', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['项目对接'].length - 1" class="col-0 mr5" @click="addPartner('项目对接')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">项目经理</div>
          <!-- <a class="col-0 mr5" @click="addPartner('项目经理')">
            <i class="el-icon-circle-plus"/>
          </a>-->
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['项目经理']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['项目经理'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('项目经理', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['项目经理'].length - 1" class="col-0 mr5" @click="addPartner('项目经理')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
        <div class="flex-row mb5">
          <div class="col-0 propject_detail_info_label mr5">项目成员</div>
          <!-- <a class="col-0 mr5" @click="addPartner('项目成员')">
            <i class="el-icon-circle-plus"/>
          </a>-->
          <div class="col-1 flex-row flex-wrap flex_wrap_container">
            <div v-for="(item, index) in changes['项目成员']" :key="index" class="flex_wrap_item">
              <el-select v-model="changes['项目成员'][index]" filterable size="mini">
                <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
              </el-select>
              <a class="col-0 mr5 danger" @click="removePartner('项目成员', index)"> <i class="el-icon-remove" /> </a>
              <a v-if="index === changes['项目成员'].length - 1" class="col-0 mr5" @click="addPartner('项目成员')">
                <i class="el-icon-circle-plus" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="dialogTitle === '领导介绍' || dialogTitle === '目标人选'"> -->
      <div v-if="dialogTitle === '目标人选'">
        <!-- <div
          v-if="dialogTitle === '领导介绍'"
          class="mb10"
        >{{ selectedLeader.name || '匿名' }}：{{ selectedLeader.description }}</div>-->
        <div v-if="dialogTitle === '目标人选'" class="flex-row flex-wrap item-center mb5">
          <div v-for="(value, i) in changes['目标人选']" :key="i" class="label_tag">{{ value.name }}</div>
        </div>
        <div class="drawer-tips ft-gray">
          人选关键词搜索的几种格式： 1、姓名； 2、姓名+空格+公司； 3、姓名+空格+公司+空格+部门； 4、手机号；
        </div>
        <el-input
          v-model="searchWords"
          placeholder="输入关键字，按回车搜索"
          size="mini"
          clearable
          @keypress.native="
            e => {
              e.keyCode === 13 && searchRadishes()
            }
          "
        >
          <el-button slot="append" type="primary" icon="el-icon-search" size="mini" @click="searchRadishes"
            >搜索</el-button
          >
        </el-input>
        <el-table :data="searchResult" size="mini" style="width: 100%" height="300px">
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <a @click="onSelectRadish(scope.row)">选择</a>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div>
                <span class="drawer-link" @click="showRadishDetail(scope.row)">{{ scope.row['姓名'] }}</span>
              </div>
              <div style="color:#aaa">{{ scope.row['手机'] }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="公司" label="公司" />
          <el-table-column prop="部门" label="部门" />
          <el-table-column prop="目前职位" label="目前职位" />
        </el-table>
      </div>
      <div v-if="dialogTitle === '客户特殊要求'" class="propject_detail_info_block">
        <p class="propject_detail_info_title">客户特殊要求</p>
        <div class="display-flex mb10">
          <span class="keep-all">寻访：</span>
          <el-input
            v-model="project['特殊要求寻访']"
            type="textarea"
            :rows="3"
            :placeholder="`例如：1、某些企业的人不能推荐；`"
          >
          </el-input>
        </div>
        <div class="display-flex mb10">
          <span class="keep-all">推荐：</span>
          <el-input
            v-model="project['推荐备注']"
            type="textarea"
            :rows="3"
            :placeholder="
              `例如：
1、推荐人选的期望薪资写在邮件正文，不能写在推荐报告；
2、推荐报告特殊模板；
3、简历推荐除了邮件之后要上系统，系统地址：http://www.wertyu.com.cn`
            "
          >
          </el-input>
        </div>
        <div class="display-flex mb10">
          <span class="keep-all">面试安排：</span>
          <el-input
            v-model="project['面试安排']"
            type="textarea"
            :rows="3"
            :placeholder="
              `例如：
    1、人选面试的时候要带身份证，公司楼下有门禁；
    2、面试安排要抄送人力加上业务领导；`
            "
          >
          </el-input>
        </div>
        <div class="display-flex mb10">
          <span class="keep-all">其他：</span>
          <el-input v-model="project['客户特殊要求']" type="textarea" :rows="3" placeholder=""> </el-input>
        </div>

        <!-- <el-input v-model="project['客户特殊要求']" type="textarea" autosize /> -->
        <p class="propject_detail_info_title">
          相关附件 <a @click="upload('特殊要求')"> <i class="el-icon-circle-plus" /> </a>
        </p>
        <div class="propject_detail_info_table">
          <div class="flex-row">
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 propject_detail_info_label"
              >类型</span
            >
            <span
              class="propject_detail_info_table_cell propject_detail_info_files_cell_1 propject_detail_info_label col-1"
              >文件名</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 propject_detail_info_label"
              >上传时间</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 propject_detail_info_label"
              >上传人</span
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_4 propject_detail_info_label"
              >操作</span
            >
          </div>
          <div
            v-for="(value, i) in filesFilter('特殊要求')"
            :key="i"
            :class="`flex-row item-center ${i % 2 === 0 ? 'bg-gray' : ''}`"
          >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_0 col-0">{{
              value.type
            }}</span>
            <a
              class="propject_detail_info_table_cell propject_detail_info_files_cell_1 col-1"
              @click="previewFile(value)"
              >{{ value.originalname }}</a
            >
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_2 col-0">{{
              value.createdAt ? dateFormat(new Date(parseInt(value.createdAt, 10)), 'yyyy-mm-dd') : '--'
            }}</span>
            <span class="propject_detail_info_table_cell propject_detail_info_files_cell_3 col-0">{{
              value.uploader
            }}</span>
            <a
              v-if="userInservice"
              class="propject_detail_info_table_cell propject_detail_info_files_cell_4 col-0"
              @click="download(value)"
              >下载</a
            >
          </div>
        </div>
      </div>
      <div v-if="dialogTitle === '附件类型'">
        <el-select v-model="fileType" filterable placeholder="请选择文件类型">
          <el-option v-for="item in projectFileTypes" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div v-if="dialogTitle === '复制项目'">
        <el-alert title="可以根据项目编号来搜索" type="warning"> </el-alert>
        <el-select v-model="copiedProId" placeholder="请选择项目" size="mini" filterable style="width:100%">
          <el-option v-for="item in proOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="mr10"> <el-button size="mini" type="danger" @click="onCancel">取 消</el-button> </span>
        <el-button v-if="dialogTitle === '附件类型'" size="mini" type="primary" @click="upload()">下一步</el-button>
        <el-button v-else size="mini" type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="完善人选画像"
      :visible.sync="dialogVisible2"
      :modal="false"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-alert
        title="人才画像未填写完善，会影响一键匹配以及智能匹配，建议完善人才匹配信息。"
        type="warning"
      ></el-alert>
      <div class="flex-row flex-wrap propject_detail_info_block_item">
        <div class="flex-row col-6 mb5">
          <div :class="`col-0 propject_detail_info_label mr5 ${errors['职能模块'] ? 'ft-danger' : ''}`">职能模块</div>
          <el-autocomplete
            v-model="project['职能模块']"
            :fetch-suggestions="(queryString, cb) => autocomplateSuggestions(queryString, cb, categoryOptions)"
            size="mini"
            placeholder="搜索关键字"
            class="col-1"
          />
        </div>
        <div class="flex-row col-6 mb5">
          <div :class="`col-0 propject_detail_info_label mr5 ${errors['平台'] ? 'ft-danger' : ''}`">平台</div>
          <div class="col-1">
            <el-select v-model="project['平台']" multiple size="mini" class="full-width">
              <el-option v-for="(value, i) in ['A', 'B', 'C']" :key="i" :value="value" :label="value" />
            </el-select>
          </div>
        </div>
        <div class="flex-row col-6 mb5">
          <div class="col-0 propject_detail_info_label mr5">细分职能</div>
          <div class="col-1">
            <el-select v-model="project['细分职能']" multiple filterable size="mini" class="full-width">
              <el-option v-for="(value, i) in 细分职能options" :key="i" :value="value" :label="value" />
            </el-select>
          </div>
        </div>
        <div class="flex-row col-6 mb5">
          <div :class="`col-0 propject_detail_info_label mr5 ${errors['业绩'] ? 'ft-danger' : ''}`">业绩</div>
          <div class="col-1">
            <el-select v-model="project['业绩']" multiple filterable size="mini" class="full-width">
              <el-option v-for="(value, i) in 业绩options" :key="i" :value="value" :label="value" />
            </el-select>
          </div>
        </div>
        <div class="flex-row col-6 mb5">
          <div class="col-0 propject_detail_info_label mr5">擅长方向</div>
          <div class="col-1">
            <el-select v-model="project['擅长方向']" multiple filterable size="mini" class="full-width">
              <el-option v-for="(value, i) in 擅长方向options" :key="i" :value="value" :label="value" />
            </el-select>
          </div>
        </div>
        <div class="flex-row col-6 mb5">
          <div :class="`col-0 propject_detail_info_label mr5 ${errors['职级'] ? 'ft-danger' : ''}`">职级</div>
          <div class="col-1">
            <el-select v-model="project['职级']" multiple filterable size="mini" class="full-width">
              <el-option v-for="(item, i) in professionalLevel" :key="i" :value="item.value" :label="item.label" />
            </el-select>
          </div>
        </div>
        <div class="flex-row col-6 mb5">
          <div class="col-0 propject_detail_info_label mr5">目标行业</div>
          <div class="col-1">
            <el-select v-model="project['目标行业']" multiple filterable size="mini" class="full-width">
              <el-option v-for="(value, i) in industry" :key="i" :value="value" :label="value" />
            </el-select>
          </div>
        </div>
        <div class="flex-row col-6 mb5">
          <div :class="`col-0 propject_detail_info_label mr5 ${errors['地域'] ? 'ft-danger' : ''}`">地域</div>
          <div class="col-1">
            <el-select v-model="project['地域']" multiple filterable allow-create size="mini" class="full-width">
              <el-option v-for="(value, i) in locations" :key="i" :value="value" :label="value" />
            </el-select>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="mr10"> <el-button size="mini" type="primary" @click="confirmSave">确认保存</el-button> </span>
        <el-button size="mini" @click="confirmSave">暂不完善</el-button>
      </span>
    </el-dialog>
    <UploadDialog ref="upload" :on-success="uploadSuccess" :type="fileType" :label="fileType" />
    <ParseResult :visible.sync="parseResultVisible" :data="parseResult" />
    <!-- 搜索人选弹窗 -->
    <serch-radish-dialog
      ref="serchRadishDialog"
      :could-insert="true"
      choose-btn-text="选择"
      :could-choose-more="true"
      @choose="chooseRadish"
      @chooseMore="chooseMoreRadish"
    ></serch-radish-dialog>
    <!-- 新增面试地址 -->
    <addCompanyAddress ref="addCompanyAddress" @addAddress="addAddress"></addCompanyAddress>

    <!-- 关键面试决策人弹窗 -->
    <serch-radish-dialog
      ref="newAddProjectSearchRadish"
      :could-insert="true"
      choose-btn-text="选择"
      @choose="chooseNewRadish"
    >
    </serch-radish-dialog>

    <!-- 选择同步到公司的数据 -->
    <choossAddToCompany
      ref="choossAddToCompany"
      :project="project"
      :company="company"
      @cancel="cancelEdit(project)"
      @projectAddCompanyData="projectAddCompanyData"
    ></choossAddToCompany>
    <!-- 填写评分组件 -->
    <ProjectGradeDialog
      ref="ProjectGradeDialog"
      show-jump
      @confirm="confirmGradeDialog"
      @close="closeGradeDialog"
    ></ProjectGradeDialog>
  </div>
</template>

<script>
import { SlickList, SlickItem } from 'vue-slicksort'
import ParseResult from '../dialog/ParseResult.vue'
import serchRadishDialog from '../../../company/src/component/serchRadishDialog.vue'
import addCompanyAddress from '../../../company/src/dialog/addCompanyAddress'
import choossAddToCompany from './AddProject/chooseAddToCompany'
import ProjectGradeDialog from './ProjectGradeDialog'
// 组件已弃用

import { arrRemove, download, parseTemplateText } from '../constant/utils'
import {
  professionalLevel,
  业绩,
  locations,
  tags,
  professionalRank,
  projectStatus,
  companyKeyWordLabel,
  projectFileTypes,
} from '../constant/type'

const dateFormat = require('dateformat')

const defaultProject = {
  标签: [],
  startTime: Date.now(),
  年龄要求: ['', ''],
  年薪范围: ['', ''],
  月薪范围: ['', ''],
  工作年限: ['', ''],
  优先级: 1,
  项目状态: '进展中',
}

const defaultCompany = {
  公司亮点: {
    content: '',
    keywords: {
      人员整体素质高: false,
      压力小: false,
      固薪高: false,
      大平台: false,
      文化好: false,
      激励机制好: false,
      稳定: false,
      股东实力强: false,
    },
  },
  '业务特点/风格/资源来源': {
    content: '',
    keywords: {
      A: false,
      B: false,
      C: false,
      D: false,
      E: false,
      F: false,
    },
  },
  面试地址: [],
}

export default {
  components: {
    SlickItem,
    SlickList,
    ParseResult,
    serchRadishDialog,
    addCompanyAddress,
    choossAddToCompany,
    ProjectGradeDialog,
  },
  props: {
    show: { type: Boolean, default: false },
    projectId: { type: String, default: undefined },
    onClose: { type: Function, default: undefined },
    onProjectUpdated: { type: Function, default: undefined },
    onCompanyUpdated: { type: Function, default: undefined },
  },
  data() {
    return {
      projectLoading: false,
      projectPending: false,
      companyLoading: false,
      filesLoading: false,
      project: window._.cloneDeep(defaultProject),
      company: window._.cloneDeep(defaultCompany),
      files: [],
      dialogVisible: false,
      dialogTitle: undefined,
      fileType: '',
      baseInfoCollapsed: false,
      portraitEditing: false,
      categoryObj: {},
      tagInputVisible: false,
      tagInput: '',
      grabbingTagIndex: undefined,
      leaderName: undefined,
      leaderDesc: undefined,
      leaderLink: undefined,
      addLeaderVisible: false,
      searchResult: [],
      searchWords: '',
      selectedLeader: undefined,
      visible: false,
      changes: {},
      templateText: '',
      errors: {},
      addCompanyVisible: false,
      companyPendding: false,
      companyFullname: '',
      companyShortname: '',
      companyIndustry: '',
      companyHRVisible: false,
      interviewAddrInput: '',
      interviewRemarkInput: '',
      oldCompanyName: '',
      deletePeddingArr: [],
      companyLeadersVisible: false,
      parseResult: {},
      parseResultVisible: false,
      proOptions: [],
      copiedProId: '',
      dialogVisible2: false,
      showNewComBtn: false,
      projectHrids: [],
      projectHRs: [],
      tags: tags,
      interviewer: [],
      temporaryHr: [],
      host: 'https://www.aconsulting.top',
      companyAddressVisible: false,
      // 是否在职，在职true
      userInservice: true,
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
    // host() {
    //   return window.host
    // },
    categories() {
      return window.app.categories || []
    },
    accounts() {
      return window.app.accounts || []
    },
    categoryOptions() {
      return this.categories.map(category => ({
        label: category['名称'],
        value: category['名称'],
      }))
    },
    细分职能options() {
      return this.categoryObj['二级职能'] || []
    },
    擅长方向options() {
      return this.categoryObj['擅长方向'] || []
    },
    professionalLevel() {
      return professionalLevel
    },
    业绩options() {
      return 业绩
    },
    industry() {
      return app.industries || []
    },
    locations() {
      return locations
    },
    locationOptions() {
      return this.locations.map(loc => ({
        label: loc,
        value: loc,
      }))
    },
    professionalRank() {
      return professionalRank
    },
    projectStatus() {
      return projectStatus
    },
    defaultCompany() {
      return defaultCompany
    },
    // projectHRs() {
    //   if (!this.company._id) return []
    //   return (this.projectHrids || []).map(HRid => {
    //     const parsed = HRid.split('.')
    //     const hrs = this.company['对接hr'] || []
    //     return hrs.find(hr => hr['姓名'] === parsed[0] && hr['手机'] === parsed[1])
    //   })
    // },
    companyKeyWordLabel() {
      return companyKeyWordLabel
    },
    projectMembers() {
      const projectMembers = []
      const project = this.project
      if (project['客户开发']) projectMembers.push(...project['客户开发'])
      if (project['项目对接']) projectMembers.push(...project['项目对接'])
      if (project['项目经理']) projectMembers.push(...project['项目经理'])
      if (project['项目成员']) projectMembers.push(...project['项目成员'])
      return [...new Set(projectMembers)]
    },
    projectLeaders() {
      if (!this.company._id) return []
      const leaderIds = this.project.leaderIds || []
      return (this.company['领导'] || []).filter(leader => leaderIds.includes(leader._id))
    },
    projectFileTypes() {
      return projectFileTypes
    },
    download() {
      return download
    },
    // host() {
    //   return window.host
    // },
  },
  watch: {
    async projectHrids(newValue, oldValue) {
      const res = await app.service('company').getCompanyHrsByIds(newValue || [])
      this.projectHRs = res.status === 'success' ? res.data : []
    },
    projectId: {
      handler(value, oldValue) {
        if (value === oldValue) return
        this.getProject()
        this.company = window._.cloneDeep(defaultCompany)
      },
      immediate: true,
    },
    project: {
      async handler(value, oldValue) {
        if (value) {
          const category = value['职能模块']
          const clientCompany = value['客户公司'] && value['客户公司'].trim()
          if (category) {
            const categoryObj = this.categories.find(obj => category === obj['名称'])
            this.categoryObj = Object.assign({}, categoryObj)
          }
          if (clientCompany) {
            // TODO abort上一条pendding请求
            if (this.oldCompanyName === clientCompany) {
              return
            }
            this.oldCompanyName = clientCompany

            this.updateProjectCompany(value)

            const res = await window.app.service('company').duplicate({ 简称: clientCompany })
            if (res === '重复') {
              this.showNewComBtn = true
            } else {
              this.companyShortname = clientCompany
              this.showNewComBtn = false
            }
          } else {
            this.showNewComBtn = true
          }
          this.getInterviewer()
          this.getTemporaryHrs()
        }
      },
      immediate: true,
      deep: true,
    },
    show: {
      handler(value, oldValue) {
        if (value === oldValue) return
        this.visible = value
      },
      immediate: true,
    },
    async companyFullname(value, oldValue) {
      if (value === oldValue) return
      // TODO abort上一条pendding请求
      const res = await window.app.service('company').duplicate({ 公司名称: value })
      if (res === '重复') {
        this.errors = Object.assign({}, this.errors, { 公司全称: true })
      } else {
        delete this.errors['公司全称']
      }
    },
    visible: {
      handler(value) {
        if (value) {
          this.templateText = ''
          this.$nextTick(() => {
            this.btnReLocation()
          })
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
    if (!app.categories) {
      await app.getCats()
    }
    if (!app.accounts) {
      await app.getUsers()
    }
  },
  methods: {
    addAddress2Project(item) {
      if (!this.project['面试地址']) {
        this.project['面试地址'] = [item]
      } else if (this.project['面试地址'].every(val => val._id !== item._id)) {
        this.project['面试地址'].push(item)
        this.companyAddressVisible = false
      }
    },
    openGradeDialog() {
      this.$refs.ProjectGradeDialog && this.$refs.ProjectGradeDialog.open(this.project, this.company)
    },
    closeGradeDialog() {
      this.$refs.ProjectGradeDialog && this.$refs.ProjectGradeDialog.parentClose()
      this.$router.push(`/project20/${this.project._id}`)
      this.visible = false
    },
    async confirmGradeDialog(option) {
      try {
        await app.service('project').modify({ id: this.project._id, param: option })
        for (const key in option) {
          this.$set(this.project, key, option[key])
        }
        this.closeGradeDialog()
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    projectAddCompanyData() {
      this.$emit('getProject')
    },
    addQuestion() {
      if (!this.project.关注问题) this.$set(this.project, '关注问题', [])
      this.project.关注问题.push('')
    },
    removeQuestion(index) {
      this.project.关注问题.splice(index, 1)
    },
    chooseNewRadish(radish) {
      if (this.newinsertType === 'interviewer') this.chooseInterviewer(radish)
      else if (this.newinsertType === 'hr') this.chooseHr(radish)
    },
    addInterviewer() {
      this.newinsertType = 'interviewer'
      this.$refs.newAddProjectSearchRadish.open()
    },
    chooseInterviewer(radish) {
      if (!this.project['关键面试人']) this.$set(this.project, '关键面试人', [])
      if (!this.project['关键面试人'].includes(radish._id)) this.project['关键面试人'].push(radish._id)
      this.getInterviewer()
    },
    async chooseHr(radish) {
      const result = this.company.对接hr.find(hr => hr.rid === radish._id)
      if (result) return
      const hr = { rid: radish._id, cid: this.company._id }
      try {
        const res = await app.service('company').addCompanyHr(hr)
        if (res.status === 'success') {
          if (!this.company.对接hr) this.company.对接hr = []
          this.company.对接hr.push(res.data)
          this.company.对接hr = await this.hr2radish(this.company.对接hr)
          this.addProjectHR(res.data)
          this.$message.success(`操作成功`)
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e)
      }
      // if (!this.project['项目对接hr']) this.$set(this.project, '项目对接hr', [])
      // if (!this.project['对接hr'].includes(radish._id) && !this.project['项目对接hr'].includes(radish._id))
      //   this.project['项目对接hr'].push(radish._id)
      // this.getTemporaryHrs()
    },
    async getTemporaryHrs() {
      const ids = this.project['项目对接hr']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.temporaryHr = res.data
      } else this.temporaryHr = []
    },
    async getInterviewer() {
      const ids = this.project['关键面试人']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.interviewer = res.data
      } else this.interviewer = []
    },
    removeTemporaryHr(hr) {
      const index = this.temporaryHr.findIndex(_hrid => _hrid === hr._id)
      const idIndex = this.project['项目对接hr'].findIndex(_hrid => _hrid === hr._id)
      if (index === -1) return
      this.project['项目对接hr'].splice(idIndex, 1)
      this.temporaryHr.splice(index, 1)
    },
    removeInterviewer(radish) {
      const index = this.interviewer.findIndex(_hrid => _hrid._id === radish._id)
      const idIndex = this.project['关键面试人'].findIndex(_hrid => _hrid === radish._id)
      if (index === -1) return
      this.project['关键面试人'].splice(idIndex, 1)
      this.interviewer.splice(index, 1)
    },
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    async updateProjectCompany(value) {
      const res = await app.service('company').getCompany(value['客户公司'])
      if (res.status == 200) {
        const { tags, 用人偏好: companyTag, 公司备注: alphaCognize } = res.result
        this.company = res.result
        if (alphaCognize) this.$set(this.project, '阿尔法认知', alphaCognize)
        if (res.result['特殊要求']) this.project['客户特殊要求'] = res.result['特殊要求']
        this.company.对接hr = await this.hr2radish(this.company.对接hr)
        if (!tags || typeof tags !== 'object' || Object.keys(tags).length === 0) return
        for (const type in tags) {
          tags[type].forEach(tag => {
            if (!this.project['标签'].includes(tag)) this.project['标签'].push(tag)
          })
        }
        if (companyTag && companyTag['语言能力']) {
          companyTag['语言能力'].forEach(tag => {
            if (!this.project['标签'].includes(tag)) this.project['标签'].push(tag)
          })
        }
      }
    },
    drop(event, index) {
      const temp = this.project['标签'][index]
      const tomoveTag = this.project['标签'][this.movetagindex]
      this.project['标签'].splice(index, 1, tomoveTag)
      this.project['标签'].splice(this.movetagindex, 1, temp)
    },
    allowDrop(event, index) {
      event.preventDefault()
    },
    drag(index) {
      this.movetagindex = index
    },
    dragtagclose(tag, tagindex) {
      this.project['标签'].splice(tagindex, 1)
    },
    // 新增对接hr
    async insertCompanyHr() {
      let defaultSearchRadishes = []
      const res = await app.service('company').defaultSearchHrs(this.company.简称)
      if (res.status == 'success') defaultSearchRadishes = res.data
      else this.$message.error(res.msg)
      // this.$refs.serchRadishDialog.open({ 公司: this.company.简称 }, defaultSearchRadishes)
      // this.insertType = 'hr'
      this.$refs.newAddProjectSearchRadish.open({ 公司: this.company.简称 }, defaultSearchRadishes)
      this.newinsertType = 'hr'
      this.$el.click()
    },
    checkDuplicateHr(radish) {
      const result = this.company.对接hr.find(hr => hr.rid === radish._id)
      return !result
    },
    async addCompanyHr(radish) {
      const leader = { rid: radish._id, cid: this.company._id }
      try {
        const res = await app.service('company').addCompanyHr(leader)
        if (res.status === 'success') {
          if (!this.company['对接hr']) this.company['对接hr'] = []
          const hr = {
            _id: res.data._id,
            rid: radish._id,
            cid: res.data.cid,
            姓名: radish.姓名,
            目前职位: radish.目前职位,
            职级: radish.职级,
            手机: radish.手机,
            座机: radish.座机,
            邮箱: radish.邮箱,
          }
          this.company['对接hr'].push(hr)
          this.$message.success(`操作成功`)
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e)
      }
    },
    // 面试地址
    async removeCompanyAddress(_id) {
      this.project['面试地址'] = this.project['面试地址'].filter(ele => ele._id !== _id)
      // if (!id) return
      // this.$confirm('是否确定删除该地址', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // })
      //   .then(async () => {
      //     if (this.deletePeddingArr.includes(id)) return
      //     this.deletePeddingArr.push(id)
      //     try {
      //       await app.service('company').removeCompanyAddress(id)
      //       this.company['面试地址'] = this.company['面试地址'].filter(address => address._id !== id)
      //       this.$message.success('删除成功')
      //     } catch (e) {
      //       this.$message.error(e.message)
      //     }
      //     arrRemove(this.deletePeddingArr, target => target === id)
      //   })
      //   .catch(() => {
      //     this.$message.info('已取消删除')
      //   })
    },
    toAddAddress() {
      this.$refs.addCompanyAddress.open()
    },
    async addAddress(obj) {
      obj.cid = this.company._id
      try {
        const res = await app.service('company').addCompanyAddress(obj)
        if (res.status === 'success') this.company['面试地址'] = res.data
        this.$message.success(`操作成功`)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    // 领导介绍相关
    async showAddCompanyLeaderDialog() {
      let defaultSerchRadishes = []
      const res = await app.service('company').defaultSerchLeaders(this.company.简称)
      if (res.status == 'success') {
        defaultSerchRadishes = res.data
      } else {
        this.$message.error(res.msg)
      }
      this.$refs.serchRadishDialog.open({ 公司: this.company.简称 }, defaultSerchRadishes)
      this.insertType === 'leader'
    },
    chooseMoreRadish(radishes) {
      for (const radish of radishes) {
        this.chooseRadish(radish)
      }
    },
    chooseRadish(radish) {
      if (this.insertType === 'hr') {
        const couldInsert = this.checkDuplicateHr(radish)
        if (couldInsert) this.addCompanyHr(radish)
        else this.$message.warning('该人选已添加，请勿重复操作')
      } else if (this.insertType === 'leader') {
        const couldInsert = this.checkDuplicateLeader(radish)
        if (couldInsert) this.addCompanyLeader(radish)
        else this.$message.warning('该人选已添加，请勿重复操作')
      }
    },
    checkDuplicateLeader(radish) {
      const result = this.company['领导'].find(leader => leader.rid === radish._id)
      return !result
    },
    async addCompanyLeader(radish) {
      const leader = { rid: radish._id, cid: this.company._id }
      try {
        const res = await app.service('project').addCompanyLeader(leader)
        if (!this.company['领导']) this.company['领导'] = []
        const companyLeader = {
          _id: res._id,
          rid: radish._id,
          姓名: radish.姓名,
          目前职位: radish.目前职位,
          简介: radish.简介,
        }
        this.company['领导'].push(companyLeader)
        this.addLeader2Project(res._id)
        this.$message({ type: 'success', message: '添加成功' })
      } catch (e) {
        this.$message.error(e)
      }
    },
    //
    initProject() {
      const arrayFields = ['细分职能', '擅长方向', '目标行业', '平台', '业绩', '职级', '地域', '标签']
      arrayFields.forEach(val => {
        if (this.project[val]) {
          if (!Array.isArray(this.project[val])) this.$set(this.project, val, [this.project[val]])
        } else this.$set(this.project, val, [])
      })
    },
    open(pro) {
      this.visible = true
      this.projectHrids = []
      if (pro) {
        const project = Object.assign({}, window._.cloneDeep(pro), {
          startTime: Date.now(),
          项目状态: '进展中',
        })
        const delFields = [
          '_id',
          '__requestId',
          '__requestSender',
          'files',
          '预计推荐时间',
          '实际推荐时间',
          '项目人才',
          'Y',
          'F',
          ' N',
          '未沟通',
          '已推荐',
          '面试',
          '终面',
          'offer',
          '到岗',
          'auc_score',
          'remark',
          '客户分类',
          '客户打分',
          '客户打分明细',
          '客户打分用户',
          '修改历史',
          '编号',
        ]
        delFields.forEach(f => {
          delete project[f]
        })
        // this.project = project
        this.project = Object.assign({}, defaultProject, project)
        this.projectHrids = project.对接hr || []
      } else {
        const account = window.app.user && window.app.user.account
        this.project = Object.assign({}, window._.cloneDeep(defaultProject), {
          项目成员: [account],
        })
      }
      this.loadPros()
      this.initProject()
      this.company = Object.assign({}, window._.cloneDeep(defaultCompany))
    },
    close() {
      this.visible = false
      this.onClose && this.onClose()
    },
    async getProject() {
      this.projectLoading = true
      try {
        const project = await window.app.service('project').fetch(this.projectId)
        if (!project['专业职级'] || typeof project['专业职级'] === 'string') {
          project['专业职级'] = [project['专业职级']]
        }
        if (
          project['领导'] &&
          typeof project['领导'] === 'object' &&
          !Array.isArray(project['领导']) &&
          project['领导'].name
        ) {
          project['领导'] = [project['领导']]
        }
        this.project = Object.assign({}, defaultProject, project)
        this.projectHrids = this.project['对接hr'] || []
        this.initProject()
        this.getCompany(project['客户公司'])
        this.getProjectFiles(this.project._id)
      } catch (error) {
        this.$message.error(error.message)
      }
      this.projectLoading = false
    },
    async getCompany(companyName) {
      if (!companyName) return
      this.companyLoading = true
      try {
        const { result } = await window.app.service('company').getCompany(companyName)
        this.company = Object.assign({}, defaultCompany, result)
        this.company.对接hr = await this.hr2radish(this.company.对接hr)
        this.company.领导 = await this.leaders2radish(this.company.领导)
        this.project.面试地址 = []
        this.project.对接hr = []
      } catch (e) {
        console.error(e)
      }

      this.companyLoading = false
    },
    async hr2radish(hrs) {
      const res = await app.service('company').getCompanyHr(hrs || [])
      if (res.status === 'success') return res.data
      else {
        this.$message(res.msg)
        return []
      }
    },
    loadPros: async function() {
      if (!app.projects) {
        await app.getProjects()
      }
      const proData = app.projects
      if (proData && proData.length > 0) {
        this.proOptions = proData.map(item => {
          const label = `${item['项目名称']}(${item['客户公司']})(${item.编号})`
          return { label: label, value: item._id }
        })
      }
    },
    async leaders2radish(leaders) {
      const res = await window.app.service('company').getLeaders(leaders)
      if (res.status === 'success') return res.data
      else {
        this.$message(res.msg)
        return []
      }
    },
    async getProjectFiles(projectId) {
      if (!projectId) {
        this.files = []
        return
      }
      this.filesLoading = true
      try {
        const { data } = await window.app.service('file').projectFiles({ query: { projectId } })
        this.files = data
      } catch (e) {
        console.error(e)
      }
      this.filesLoading = false
    },
    showDialog(dialogTitle) {
      this.dialogVisible = true
      this.dialogTitle = dialogTitle
    },
    onCancel() {
      const dialogTitle = this.dialogTitle
      if (dialogTitle === '参与成员') {
        this.cancelEdit({
          客户开发: true,
          项目对接: true,
          项目经理: true,
          项目成员: true,
        })
      }
      if (dialogTitle === '目标人选') {
        this.cancelEdit({ 目标人选: true })
      }
      this.dialogVisible = false
    },
    async onConfirm() {
      const { changes, dialogTitle } = this
      if (dialogTitle === '参与成员') {
        this.updateProject({
          客户开发: (changes['客户开发'] && changes['客户开发'].filter(Boolean)) || [],
          项目对接: (changes['项目对接'] && changes['项目对接'].filter(Boolean)) || [],
          项目经理: (changes['项目经理'] && changes['项目经理'].filter(Boolean)) || [],
          项目成员: (changes['项目成员'] && changes['项目成员'].filter(Boolean)) || [],
        })
      }
      if (dialogTitle === '目标人选') {
        this.updateProject({
          目标人选: (changes['目标人选'] && changes['目标人选'].filter(Boolean)) || [],
        })
      }
      if (dialogTitle === '复制项目') {
        if (this.copiedProId) {
          const project = await window.app.service('project').fetch(this.copiedProId)
          this.open(project)
          this.dialogVisible = false
        } else {
          this.$message.info('请选择项目')
        }
      }
      this.dialogVisible = false
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.upload.visible()
      const res = response[0]
      const projectId = this.project._id
      const type = this.fileType
      if (projectId) {
        try {
          await window.app.service('project').insertProjectFile([
            Object.assign(response[0], {
              type,
              projectId,
            }),
          ])
          this.getProjectFiles(projectId)
        } catch (e) {
          this.$message.error(e.message)
        }
      } else {
        this.files.push(Object.assign(res, { type }))
      }
    },
    upload(type, parseAfterUpload) {
      this.fileType = type
      this.$refs.upload.visible(true)
      this.$refs.upload.$on(
        'uploaded',
        parseAfterUpload
          ? async response => {
              if (response && response[0]) {
                const json = app.service('project').parseProjectTemplateByFile(response[0])
                this.parseTemplateText(json)
              }
            }
          : null,
      )
    },
    editProjectField(field) {
      this.changes = Object.assign({}, this.changes, {
        [field]: this.project[field],
      })
    },
    filesFilter(type) {
      const files = this.files
      if (!type) return files
      return files.filter(val => val.type === type || (val.response && val.response[0].type === type))
    },
    selectCompany() {
      app.root.$refs.selectCompany.open(this.project['目标公司'] || [], value => {
        this.updateProject({ 目标公司: value })
      })
      // window.app.root.$refs.targetCompany.show({
      //   defaultCompanies: this.project['目标公司'] || [],
      //   onConfirm: value => {
      //     this.updateProject({ 目标公司: value })
      //   },
      // })
    },
    cancelEdit(params) {
      if (typeof params === 'string') {
        delete this.changes[params]
      } else {
        const fields = Object.keys(params)
        fields.map(field => {
          delete this.changes[field]
        })
      }
      this.changes = Object.assign({}, this.changes)
    },
    async updateProject(params, cb) {
      const param =
        typeof params === 'string'
          ? {
              [params]: this.changes[params] || null,
            }
          : params
      try {
        if (param['关注问题']) param['关注问题'] = param['关注问题'].filter(val => val)

        if (this.project._id) {
          await window.app.service('project').modify({
            id: this.project._id,
            param,
          })
          this.$message({
            type: 'success',
            message: `修改成功`,
          })
        }
        this.project = Object.assign({}, this.project, param)
        this.initProject()
        cb && cb(this.project)
        this.$refs.choossAddToCompany.open({ questions: this.project.关注问题, hrs: this.temporaryHr })
        this.cancelEdit(param)
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    editPortraitToggle() {
      this.portraitEditing = !this.portraitEditing
      const project = this.project
      const changes = {
        职能模块: project['职能模块'] || '',
        业绩: project['业绩'] || [],
        细分职能: project['细分职能'] || [],
        职级: project['职级'] || [],
        擅长方向: project['擅长方向'] || [],
        地域: project['地域'] || [],
        目标行业: project['目标行业'] || [],
        平台: project['平台'] || [],
        标签: project['标签'] || [],
        目标公司备注: project['目标公司备注'] || '',
      }
      if (this.portraitEditing) {
        this.changes = Object.assign({}, this.changes, changes)
      } else {
        this.cancelEdit(changes)
      }
    },
    savePortraitEdit() {
      const changes = this.changes
      this.updateProject(
        {
          职能模块: changes['职能模块'] || '',
          业绩: changes['业绩'] || [],
          细分职能: changes['细分职能'] || [],
          职级: changes['职级'] || [],
          擅长方向: changes['擅长方向'] || [],
          地域: changes['地域'] || [],
          目标行业: changes['目标行业'] || [],
          平台: changes['平台'] || [],
          标签: changes['标签'] || [],
          目标公司备注: changes['目标公司备注'] || '',
        },
        () => {
          this.portraitEditing = !this.portraitEditing
        },
      )
    },
    autocomplateSuggestions(queryString, cb, options) {
      const results = queryString
        ? options.filter(val => val.label && val.label.toLowerCase().includes(queryString.toLowerCase()))
        : options
      cb(results)
    },
    showInput() {
      this.tagInputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput && this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      const tagInput = this.tagInput
      if (tagInput) {
        if (!this.project['标签']) {
          this.project['标签'] = []
        }
        this.project['标签'].push(tagInput)
      }
      this.tagInputVisible = false
      this.tagInput = ''
    },
    async addLeader(param, radish) {
      const leader = param
      if (!this.company['领导']) this.company['领导'] = []
      const hasdata = this.company['领导'].find(leader => leader.rid === radish._id)
      if (hasdata) return
      try {
        const res = await window.app.service('project').addCompanyLeader(leader)
        const item = Object.assign({}, res, { 姓名: radish.姓名, 目前职位: radish.目前职位, 简介: radish.简介 })

        this.company['领导'].push(item)
        this.addLeader2Project(res._id)
        this.$message({ type: 'success', message: '添加成功' })
      } catch (e) {
        this.$message.error(e)
      }
    },
    cancelAddLeader() {
      this.leaderName = ''
      this.leaderDesc = ''
      this.addLeaderVisible = false
    },
    onChangeLeader() {
      this.leaderLink = null
    },
    async searchRadishes() {
      if (!this.searchWords) return
      try {
        const { data, status, msg } = await window.app.service('misc').searchEs({
          type: '人选',
          keywords: this.searchWords,
          fields: ['姓名', '拼音', '公司', '部门', '职能模块', '手机'],
          and: true,
        })
        if (status === 'success') {
          this.searchResult = data
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.error(e)
      }
    },
    editLeader(leader) {
      this.searchWords = leader.name
      this.selectedLeader = {
        _id: leader._id,
        name: leader.name || '',
        description: leader.description || '',
      }
      this.showDialog('领导介绍')
      this.$nextTick(() => {
        this.searchRadishes()
      })
    },
    editPartners() {
      const { project } = this
      const fields = ['客户开发', '项目对接', '项目经理', '项目成员']
      fields.forEach(field => {
        const value = (project[field] && project[field].slice()) || ['']
        this.$set(this.changes, field, value)
        if (this.changes[field].length === 0) this.changes[field].push('')
      })
      this.showDialog('参与成员')
    },
    addPartner(field) {
      const value = this.changes[field] || []
      const length = value.length
      if (length === 0 || value[length - 1]) {
        value.push('')
      }
      this.changes = Object.assign({}, this.changes, { [field]: value })
    },
    removePartner(field, index) {
      const value = this.changes[field] || []
      value.splice(index, 1)
      if (value.length === 0) value.push('')
      this.changes = Object.assign({}, this.changes, { [field]: value })
    },
    onSelectRadish(radish) {
      const dialogTitle = this.dialogTitle
      if (dialogTitle === '领导介绍') {
        // this.selectedLeader.name = radish['姓名']
        // this.selectedLeader.link = radish._id
        const leader = {
          cid: this.company._id,
          rid: radish._id,
        }
        this.addLeader(leader, radish)
      }
      if (dialogTitle === '目标人选') {
        this.changes['目标人选'].push({
          name: radish['姓名'],
          link: radish._id,
        })
      }
    },
    showRadishDetail(radish) {
      window.open(`${window.frontend}/#/radish-detail-blank/${radish._id}`, '_blank')
    },
    async searchCompany(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      try {
        const { data } = await window.app.service('company').serchCompany(queryString)
        cb(
          data.map(company => ({
            label: company['简称'],
            value: company['简称'],
          })),
        )
      } catch (e) {
        console.error(e)
      }
    },
    async searchCompanyFullname(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      try {
        const { data } = await window.app.service('company').fuzzySearch({ name: queryString })
        cb(
          data.map(company => ({
            label: company.Name,
            value: company.Name,
          })),
        )
      } catch (e) {
        console.error(e)
      }
    },
    async onSave() {
      if (this.pendding) return this.$message.info('保存中，请稍等')
      this.project.对接hr = this.projectHrids
      this.checkRequired()
      if (Object.keys(this.errors).length > 0) return
      if (
        !this.project['职能模块'] ||
        this.project['细分职能'].length === 0 ||
        this.project['擅长方向'].length === 0 ||
        this.project['目标行业'].length === 0 ||
        this.project['平台'].length === 0 ||
        this.project['业绩'].length === 0 ||
        this.project['职级'].length === 0 ||
        this.project['地域'].length === 0
      ) {
        this.dialogVisible2 = true
      } else {
        await this.confirmSave()
      }
    },
    async confirmSave() {
      this.pendding = true
      this.project['部门情况'] = this.company['部门情况'] || ' '
      if (!this.project._id) {
        await this.createProject()
      } else {
        await this.updateProject(this.project, this.onProjectUpdated)
      }
      if (this.company._id) this.saveCompany()
      this.pendding = false
      this.dialogVisible2 = false
      this.openGradeDialog()
      // this.$router.push(`/project20/${this.project._id}`)
      // this.visible = false
    },
    async createProject() {
      if (this.projectPending) return this.$message.info('创建项目中，请稍等')
      this.projectPending = true
      try {
        const project = await window.app.service('project').insert(this.project)
        this.project._id = project._id
        const files = this.files
        if (files.length > 0) {
          const projectFiles = files.map(file => Object.assign(file, { projectId: project._id }))
          await window.app.service('project').insertProjectFile(projectFiles)
        }
        this.$notify({
          title: `${project['项目名称']}创建成功`,
          type: 'success',
          message: '点击查看',
          onClick: () => {
            let a = document.createElement('a')
            a.style.display = 'none'
            a.target = '_blank'
            a.href = `/#/project20/${project._id}`
            a.click()
            a = null
          },
        })
        this.onProjectUpdated && this.onProjectUpdated(project)
        await app.getProjects()
      } catch (e) {
        this.$message.error(`项目创建失败 : ${e.message}`)
        console.error(e)
      }
      this.projectPending = false
    },
    checkRequired() {
      const project = this.project
      const checkFields = ['客户公司', '项目名称', '对接hr']
      for (const field of checkFields) {
        if (!project[field] || project[field].length === 0) {
          this.errors = Object.assign({}, this.errors, { [field]: true })
          this.$message.error(`缺少“${field}”必填项`)
          break
        } else if (this.errors[field]) {
          delete this.errors[field]
        }
      }
    },
    editProjectTargetRadishes() {
      this.changes = Object.assign({}, this.changes, {
        目标人选: this.project['目标人选'] || [],
      })
      this.showDialog('目标人选')
    },
    async createCompany() {
      if (!this.companyFullname) {
        this.errors = Object.assign({}, this.errors, { 公司全称: true })
        return
      }
      if (!this.companyIndustry) {
        this.errors = Object.assign({}, this.errors, { 行业: true })
        return
      }
      if (this.companyPendding) return
      this.companyPendding = true
      try {
        const res = await window.app.service('company').insertCompany({
          company: {
            简称: this.companyShortname,
            公司名称: this.companyFullname,
            行业: this.companyIndustry,
          },
        })
        if (res.status == 200) {
          this.$message('新建公司成功')
          this.showNewComBtn = true
          this.addCompanyVisible = false
          this.getCompany(this.project.客户公司)
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e.message)
      }
      this.companyPendding = false
    },
    async addProjectHR(value) {
      const hrid = value._id
      if (this.projectHrids && this.projectHrids.length > 0) {
        const exist = this.projectHrids.find(_hrid => _hrid === hrid)
        if (exist) return
      }
      try {
        this.projectHrids.push(hrid)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async addHR2Project(value) {
      const hrid = value._id
      if (this.projectHrids && this.projectHrids.length > 0) {
        const exist = this.projectHrids.find(_hrid => _hrid === hrid)
        if (exist) return
      }
      try {
        await window.app.service('project').addProjectHR({ id: this.project._id, hrid })
        this.projectHrids.push(hrid)
        this.$message({
          type: 'success',
          message: `修改成功`,
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async removeProjectHr(value) {
      const hrid = value._id
      try {
        // await window.app.service('project').removeProjectHR({ id: this.project._id, hrid })
        const index = this.projectHrids.findIndex(_hrid => _hrid === hrid)
        if (index === -1) return
        this.projectHrids.splice(index, 1)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    saveCompany() {
      const company = this.company
      if (!company._id) return
      this.updateCompany(
        {
          一句话简介: company['一句话简介'] || '',
          公司亮点: company['公司亮点'] || {
            content: '',
            keywords: {
              人员整体素质高: false,
              压力小: false,
              固薪高: false,
              大平台: false,
              文化好: false,
              激励机制好: false,
              稳定: false,
              股东实力强: false,
            },
          },
          '业务特点/风格/资源来源': company['业务特点/风格/资源来源'] || {
            content: '',
            keywords: {
              A: false,
              B: false,
              C: false,
              D: false,
              E: false,
              F: false,
            },
          },
          面试安排: company['面试安排'] || '',
          // 部门情况: company['部门情况'] || '',
          '薪酬/职级/奖金机制': company['薪酬/职级/奖金机制'] || '',
          // 面试地址: company['面试地址'] || [],
          领导介绍: company['领导介绍'] || '',
        },
        this.onCompanyUpdated,
      )
      console.log('saveCompany -> this.company', this.company['部门情况'])
      if (this.company['部门情况']) {
        // this.project['部门情况'] = this.company['部门情况']
        this.updateProject({ 部门情况: this.company['部门情况'] })
      }
      ;(company['领导'] || []).map(leader => {
        if (leader._id) this.updateCompanyLeader(leader._id, leader)
      })
      this.onCompanyUpdated && this.onCompanyUpdated(this.company)
    },
    async updateCompany(params, cb) {
      if (!this.company._id) return
      const param =
        typeof params === 'string'
          ? {
              [params]: this.changes[params] || null,
            }
          : params
      try {
        await window.app.service('company').modifyCompany({
          query: { _id: this.company._id },
          data: param,
        })
        this.company = Object.assign({}, this.company, param)
        cb && cb(this.company)
        this.cancelEdit(param)
        this.$message({
          type: 'success',
          message: `修改成功`,
        })
      } catch (e) {
        this.$message.error(`update company :${e.message}`)
      }
    },
    // addInterviewAddr() {
    //   if (!this.interviewAddrInput || !this.interviewAddrInput.trim()) return
    //   this.company['面试地址'].push({
    //     地址: this.interviewAddrInput,
    //     备注: this.interviewRemarkInput,
    //   })
    //   this.interviewAddrInput = ''
    //   this.interviewRemarkInput = ''
    // },
    // removeInterviewAddr(index) {
    //   this.company['面试地址'].splice(index, 1)
    // },
    async previewFile(file) {
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    async removeCompanyLeader(id, _index) {
      if (!id) return
      if (this.deletePeddingArr.includes(_index)) return
      this.deletePeddingArr.push(_index)
      try {
        await window.app.service('project').removeCompanyLeader(id)
        arrRemove(this.company['领导'], leader => leader._id === id)
        this.$message({
          type: 'success',
          message: '删除成功',
        })
      } catch (e) {
        this.$message.error(e.message)
      }
      arrRemove(this.deletePeddingArr, target => target === _index)
    },
    async updateCompanyLeader(id, param) {
      if (!id) return
      if (param && param._id) delete param._id
      try {
        await window.app.service('project').updateCompanyLeader({
          id,
          param,
        })
        if (this.selectedLeader) this.selectedLeader = undefined
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    uploadRadishFile(rid) {
      this.toUploadRid = rid
      this.showDialog('领导附件上传')
    },
    beforeUpload() {
      this.showDialog('附件类型')
    },
    btnReLocation() {
      if (this.$refs.propject_detail_secondary) {
        const { width } = this.$refs.propject_detail_secondary.getBoundingClientRect()
        const right = `${parseInt(width, 10) + 25}px`
        if (this.editBtnRight === right) return
        this.$refs.editBtn.style.right = right
        this.editBtnRight = right
      }
    },
    async addLeader2Project(id) {
      if (!id) return
      if (!this.project.leaderIds) this.project.leaderIds = []
      const index = this.project.leaderIds.findIndex(leaderId => leaderId === id)
      if (index > -1) return
      this.project.leaderIds.push(id)
      this.updateProject({ leaderIds: this.project.leaderIds })
    },
    removeProjectLeader(id) {
      if (!id) return
      arrRemove(this.project.leaderIds, leaderId => leaderId === id)
      this.updateProject({ leaderIds: this.project.leaderIds })
    },
    parseTemplateText(_json) {
      const json = _json || parseTemplateText(this.templateText)
      const parseResult = {}
      const project = Object.assign({}, this.project)
      for (const key in json) {
        if (json.hasOwnProperty(key)) {
          const value = json[key]
          if (['目标公司', '目标人选'].includes(key)) {
            project[`${key}备注`] = value
          } else if (['平台', '业绩', '职级', '地域', '目标行业', '办公地'].includes(key) && typeof key === 'string') {
            project[key] = value.split(';').filter(Boolean)
          } else {
            project[key] = value
          }
          parseResult[key] = value
        }
      }
      this.project = Object.assign({}, project)
      this.initProject()
      this.parseResultVisible = true
      this.parseResult = Object.assign({}, parseResult)
    },
  },
}
</script>

<style>
@import '../css/main.css';
</style>
